import { HelperParams } from './helper-params';
import { BaseBuildPart } from './base-build-part';
import { Category } from '../../documents';
import { GeneralDocumentsBuildPart } from './general-documents-build-part';
import { GeneralDocumentsCommands, GlobalOutletsCommands } from './types';

export class GlobalPopupBuildPart extends BaseBuildPart {
    constructor(private readonly globalPopupHelperParams: HelperParams,
                private readonly baseBuildPartParent: BaseBuildPart) {
        super(globalPopupHelperParams, baseBuildPartParent, []);
    }

    public empty() {
        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(null));
    }

    public generalDocuments(category: Category) {
        const commands = this.getCommands(['general-documents', category.categoryId]) as GeneralDocumentsCommands;
        return new GeneralDocumentsBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, commands);
    }

    public siteCommunicationsMassUpload(): BaseBuildPart {
        const outletCommands = ['site-communications-mass-upload'];

        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands));
    }

    public user(editedUserPk: number): BaseBuildPart {
        const outletCommands = ['user', editedUserPk.toString()];

        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands) as [GlobalOutletsCommands]);
    }

    public userGeneralSettings(editedUserPk: number) {
        const outletCommands = ['user', editedUserPk.toString(), 'general-settings'];

        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands));
    }

    public userEmailSettings(editedUserPk: number) {
        const outletCommands = ['user', editedUserPk.toString(), 'email-settings'];

        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands));
    }

    public emulateUser(): BaseBuildPart {
        const outletCommands = ['emulate-user'];

        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands));
    }

    public terms(): BaseBuildPart {
        const outletCommands = ['terms-and-conditions'];
        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands));
    }

    public portaldisclaimer(): BaseBuildPart {
        const outletCommands = ['disclaimer'];
        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands));
    }

    public investigatorEQueryDetails(eQueryId: number) {
        const outletCommands = ['investigator-e-query-details', eQueryId.toString()];
        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands));
    }

    public sponsorEQueryDetails(eQueryId: number) {
        const outletCommands = ['sponsor-e-query-details', eQueryId.toString()];
        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands));
    }

    public coordinatorEQueryDetails(eQueryId: number) {
        const outletCommands = ['coordinator-e-query-details', eQueryId.toString()];
        return new BaseBuildPart(this.globalPopupHelperParams, this.baseBuildPartParent, this.getCommands(outletCommands));
    }

    private getCommands(outletCommands: string[]): any[] {
        return [{outlets: {[this.outletName]: outletCommands}}];
    }
}